import { render, staticRenderFns } from "./AssignToClass.vue?vue&type=template&id=7d976d91&scoped=true&"
import script from "./AssignToClass.vue?vue&type=script&lang=js&"
export * from "./AssignToClass.vue?vue&type=script&lang=js&"
import style0 from "./AssignToClass.vue?vue&type=style&index=0&id=7d976d91&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d976d91",
  null
  
)

export default component.exports